import { EditableStatus } from '@/main/utils/table';

export const types = <const>{
	mutations: {
		PRACOVNIK_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'PRACOVNIK_NAKLADOVE_STREDISKO_SELECT_MAPPER',
	},
};

export type ProvozovnyType = {
	AktualizacePrp: boolean,
	ProvozovnaId: number,
	UpdateStatus: EditableStatus,
};

export const editActions = <const>{
	SEND_REMINDERS: 'SEND_REMINDERS',
};
